type Hook = () => void;

export function hookPageView(onChange: (url: string, referrer: string) => void) {
  // Initial
  onChange(location.href, document.referrer);

  // SPA: pushState / replaceState / popstate
  const origPush = history.pushState;
  const origReplace = history.replaceState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const wrap = (orig: any) => function (this: any, ...args: any[]) {
    const ret = orig.apply(this, args);
    onChange(location.href, document.referrer);
    return ret;
  };
  history.pushState = wrap(origPush);
  history.replaceState = wrap(origReplace);
  window.addEventListener("popstate", () => onChange(location.href, document.referrer));
}

export function hookUnload(onUnload: Hook) {
  const fire = () => onUnload();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") fire();
  });
  window.addEventListener("pagehide", fire);
  window.addEventListener("beforeunload", fire);
}
